export const getNumFracDigits = (value: number | null | undefined) => {
    if (value !== null && value !== undefined && !Number.isNaN(value)) {
        return Number.isInteger(+value) ? 0 : 2;
    } else {
        return 0;
    }
};

const fmtCurrencyValue = (
    currencyISOCode: string,
    value: number | null | undefined,
    useTwoDigits: boolean
) => {
    const isJPY = currencyISOCode === "JPY";
    const adjVal = isJPY ? Math.ceil(value || 0) : value;

    return new Intl.NumberFormat(isJPY ? "ja-JP" : "en-US", {
        style: "currency",
        currency: currencyISOCode,
        // Note: JPY does not use decimals
        minimumFractionDigits:
            useTwoDigits && !isJPY ? 2 : getNumFracDigits(adjVal),
        maximumFractionDigits:
            useTwoDigits && !isJPY ? 2 : getNumFracDigits(adjVal)
    }).format(adjVal || 0);
};

export const getFormattedPrice = (currencyISOCode: string, value: number) =>
    fmtCurrencyValue(currencyISOCode, value, false);

export const getTwoDigitFormattedPrice = (
    currencyISOCode: string,
    value: number
) => fmtCurrencyValue(currencyISOCode, value, true);

export const getFormattedUnitAmount = (
    localeISOCode: string,
    value: number | null
) => new Intl.NumberFormat(localeISOCode).format(value || 0);
